<template>
  <div class="container flex flex-column items-center">
    <div class="ove-container flex flex-column items-center" style="margin-top:50px;">
      <div class="content" v-html="articeVO.content"></div>
    </div>
  </div>
</template>

<script>
import { articleDetail } from "@/axios/front";
import qs from "qs";
export default {
  data() {
    return {
      articeVO: {}
    };
  },
  methods: {
    handleArticleDetail(id) {
      articleDetail(id).then(res => {
        if (res.status === 200) {
          this.articeVO = res.data;
        }
      });
    }
  },
  mounted() {
    let query = qs.parse(this.$route.query);
    if (query.id - 0 > 0) {
      this.handleArticleDetail(query.id);
    }
  },
  watch:{
      $route(){
        this.handleArticleDetail(this.$route.query.id);
      }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .content {
    margin-top: 40px;
    margin-bottom: 20px;
    width: 800px;
    text-align: left;
  }
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/front/article/OtherArticle.vue